import { render, staticRenderFns } from "./DataItem.vue?vue&type=template&id=acf58e98&"
import script from "./DataItem.vue?vue&type=script&lang=ts&"
export * from "./DataItem.vue?vue&type=script&lang=ts&"
import style0 from "./DataItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports